import React from 'react'

import { NavLink, generatePath } from 'react-router-dom'

import { AppsOutline, ListOutline } from 'react-ionicons'
import { Navbar, Nav } from 'rsuite'

import { usePartner } from '@@partner:helpers/hooks/auth'

import { ROUTE_DELIVERY_ZONES_LIST, ROUTE_DELIVERY_ZONES_ON_MAP } from '@@partner:config/routes'


export default function DeliveryZonesSubMenu () {
  const { brandSlug } = usePartner()

  return (
    <Navbar appearance='subtle'>
      <Nav>
        <Nav.Item
          icon={<ListOutline />}
          as={NavLink}
          to={generatePath(ROUTE_DELIVERY_ZONES_LIST, {
            brandSlug
          })}
        >
            Список зон
        </Nav.Item>
        <Nav.Item
          icon={<AppsOutline />}
          as={NavLink}
          to={generatePath(ROUTE_DELIVERY_ZONES_ON_MAP, {
            brandSlug
          })}
        >
            Зоны на карте
        </Nav.Item>{/* 
        <Nav.Item
          icon={<AddOutline />}
          as={NavLink}
          to={generatePath(ROUTE_CATALOG_CATEGORY_ADD, {
            brandSlug
          })}
        >
            Добавить категорию
        </Nav.Item> */}
      </Nav>
    </Navbar>
  )
}